module.exports = __webpack_public_path__ + "img/intro_img2.a6022bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro_img2.png
// module id = KgN9
// module chunks = 1